import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSnackbar } from 'notistack'

import { Button } from '@mui/material'

import { useChangePasswordMutation, useSendPasswordChangeOtpMutation, useVerifyPasswordChangeOtpMutation } from '@/core/services/auth'

import ChangePasswordDialog, { ChangePasswordFormValues } from '../components/ChangePasswordDialog'

export default function ChangePasswordDialogContainer() {
  const { t } = useTranslation()
  const { enqueueSnackbar } = useSnackbar()

  const [open, setOpen] = useState(false)

  const [changePassword, { isLoading }] = useChangePasswordMutation()
  const [sendPasswordChangeOtp, { isLoading: isSendingOtp }] = useSendPasswordChangeOtpMutation()
  const [verifyPasswordChangeOtp, { isLoading: isVerifyingOtp }] = useVerifyPasswordChangeOtpMutation()

  const handleSendPasswordChangeOtp = async () => {
    try {
      await sendPasswordChangeOtp().unwrap()
      return true
    } catch (error) {
      return false
    }
  }

  const handleVerifyPasswordChangeOtp = async (otp: string) => {
    try {
      const verification = await verifyPasswordChangeOtp(otp).unwrap()
      return verification.status === 'ok'
    } catch (error) {
      return false
    }
  }

  const handleChangePassword = async (values: ChangePasswordFormValues) => {
    try {
      await changePassword({ newPass: values.password }).unwrap()
      setOpen(false)
      enqueueSnackbar(t('notification.authUser.updatePassword.success'), { variant: 'success' })
    } catch (error) {
      const status = typeof error === 'object' && error && 'status' in error ? error.status : undefined
      enqueueSnackbar(t(status === 400 ? 'notification.authUser.updatePassword.otpInvalidError' : 'notification.authUser.updatePassword.error'), {
        variant: 'error',
      })
    }
  }

  return (
    <>
      <Button color="primary" disableElevation onClick={() => setOpen(true)} variant="contained">
        {t('page.configuration.changePasswordButton.label')}
      </Button>
      <ChangePasswordDialog
        isSendingOtp={isSendingOtp}
        isSubmitting={isLoading}
        isVerifyingOtp={isVerifyingOtp}
        onClose={() => setOpen(false)}
        onSendOtp={handleSendPasswordChangeOtp}
        onVerifyOtp={handleVerifyPasswordChangeOtp}
        onSubmit={handleChangePassword}
        open={open}
      />
    </>
  )
}
